import React from 'react';
import { PageHero, SectionLabel, PrimaryButton } from '../components/Shared';
import { team, institutionalClients, images } from '../data/mock';

const About = () => {
  return (
    <>
      <PageHero
        eyebrow="מי אנחנו"
        title="אנחנו לא ”עוד סוכנות“."
        accent="אנחנו הנהלת השיווק שלכם."
        subtitle="Gal&Blizovsky משלבת בין מומחיות דיגיטלית מהשורה הראשונה לבין יכולות ניהול הנדסיות-ביצועיות של פרויקטים מורכבים."
        image={images.about}
      />

      {/* Two worlds */}
      <section className="py-20 lg:py-28 bg-cream" aria-labelledby="two-worlds">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
          <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
            <div className="lg:col-span-5 reveal">
              <SectionLabel>חברה אחת, שני עולמות כוח</SectionLabel>
              <h2 id="two-worlds" className="display-2 text-navy">אתם מחפשים אמינות, סדר, ותוצאות בשטח.</h2>
            </div>
            <div className="lg:col-span-7 reveal space-y-6 lede text-navy/75">
              <p>
                כדי לספק את זה, בנינו חברה שמשלבת DNA נדיר:
              </p>
              <p>
                מצד אחד, <strong className="text-navy">הבנה עמוקה בדיגיטל, לידים ומסעי לקוח</strong> — היכולת לקחת מסר ולתרגם אותו לתנועה ולהכנסות.
              </p>
              <p>
                מצד שני, <strong className="text-navy">סטנדרט ניהולי, הנדסי וביצועי עליון</strong> — ניסיון בניהול מערכות מורכבות, חקר כשלים, בקרה ותהליכי עבודה שאינם משאירים מקום לניחושים.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="py-24 lg:py-32 bg-cream-200" aria-labelledby="team-heading">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
          <div className="max-w-3xl mb-16 reveal">
            <SectionLabel>ההנהלה שמאחורי המערכת</SectionLabel>
            <h2 id="team-heading" className="display-2 text-navy">שני הראשים, שתי תפיסות, מערכת אחת.</h2>
          </div>

          <div className="space-y-px">
            {team.map((person) => (
              <article
                key={person.name}
                className="reveal grid lg:grid-cols-12 gap-8 lg:gap-16 py-12 lg:py-16 border-t border-navy/15 last:border-b"
              >
                <div className="lg:col-span-4">
                  <div className="aspect-[4/5] bg-navy text-cream flex items-center justify-center relative overflow-hidden">
                    {person.image ? (
                      <img
                        src={person.image}
                        alt={`תמונה של ${person.name}`}
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                    ) : (
                      <span className="font-serif text-7xl lg:text-9xl text-bronze" aria-hidden="true">{person.initials}</span>
                    )}
                    <div className="absolute inset-0 grain pointer-events-none" />
                  </div>
                </div>
                <div className="lg:col-span-8">
                  <p className="eyebrow text-bronze mb-3">{person.role}</p>
                  <h3 className="display-2 text-navy mb-6">{person.name}</h3>
                  {person.bio.split('\n\n').map((p, i) => (
                    <p key={`${person.name}-bio-${i}`} className="lede text-navy/75 text-lg mb-5">{p}</p>
                  ))}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Institutional clients */}
      <section className="py-20 lg:py-28 bg-cream" aria-labelledby="clients-heading">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
          <div className="max-w-3xl mb-12 reveal">
            <SectionLabel>גופים שעבדנו מולם</SectionLabel>
            <h2 id="clients-heading" className="display-2 text-navy">סטנדרט מוסדי שנבנה בהתערבות דיוק מרבי.</h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-px bg-navy/10 reveal">
            {institutionalClients.map((c) => (
              <div
                key={c}
                className="bg-cream-200 px-6 py-10 flex items-center justify-center text-center min-h-[120px]"
              >
                <span className="font-serif text-navy text-base lg:text-lg">{c}</span>
              </div>
            ))}
          </div>
          <div className="mt-16 reveal">
            <PrimaryButton to="/contact">להמשיך לשיחת אבחון</PrimaryButton>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
